module.exports = __webpack_public_path__ + "static/img/2-2.22dc30b.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/home/imgs/2-2.png
// module id = 0sGT
// module chunks = 1